import { createApp } from 'vue'
import PersonalDonationStep3 from './PersonalDonationStep3'

const el = '.kb-component--fundraise-step3'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((PersonalDonationStep3DOM) => {
            const component = createApp(PersonalDonationStep3).use(Store)
            component.mount(PersonalDonationStep3DOM)
        })
    }
}
